import axios from 'axios';
export default {

    paymentProsses(giftCard){
        return axios.post('/api/gift/card/get/process' , giftCard)
        .then(response => {
            if (response && response.data) return response.data
        })
    },
    
    getGiftCard(paymentRef){
        return axios.get('/api/gift/card/get' ,  {params : {paymentRef:paymentRef}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

}